import { Pipe, PipeTransform } from '@angular/core';
import { CommonCommunicationService } from 'src/app/core/services/commonCommunication.service';

@Pipe({
  name: 'hasPermission',
  standalone: true,
  pure: true
})
export class HasPermissionPipe implements PipeTransform {
  constructor(private ccs: CommonCommunicationService) {}

  transform(permissionStr: string): boolean {
    const [key, action = 'view'] = permissionStr.split('.');
    const permissions = this.ccs.rolePermission$.value;
    return !!permissions?.[key]?.[action];
  }
}
